module.exports = "<div class=\"alert alert-{{ type }}\" role=\"alert\" *ngIf=\"show\">\n    <span>{{ content }}</span>\n</div>"